export class Config {
  static versionCode: string = "1.0.0";
  static assetConfigData: any;
  static teethConfigData: any;
}
